export default {
    pdfjs: null,

    init: function() {
        this.pdfjs = window['pdfjs-dist/build/pdf'];
    },

    getInstance: function() {
        if (!this.pdfjs.GlobalWorkerOptions.workerSrc) {
            this.pdfjs.GlobalWorkerOptions.workerSrc = '/dist/js/pdfjs/pdf_worker.min.js';
        }

        return this.pdfjs;
    }
};